export default __webpack_public_path__ + "maps-examples-data-driven-symbols-960-a38471f29024f74249167b8b76f0d329.webp";